var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_509_752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5225 17.5225 22 12 22C6.4775 22 2 17.5225 2 12C2 6.4775 6.4775 2 12 2C17.5225 2 22 6.4775 22 12Z",
    fill: "url(#paint0_linear_509_752)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M5.05909 11.7329C9.13659 9.88544 13.9256 7.88094 14.6631 7.59094C16.2891 6.95144 16.9981 7.60494 16.8871 8.64744C16.7506 9.92494 16.1036 13.6424 15.7056 16.3059C15.4726 17.8644 14.6286 18.3419 13.6761 17.7374C12.9536 17.2789 10.4696 15.6524 9.81609 15.0964C9.37059 14.7174 9.06009 14.2924 9.37609 13.8594C9.46859 13.7329 9.70509 13.4779 9.83659 13.3509C10.4961 12.7119 10.4071 12.5744 9.60959 13.1449C9.51459 13.2129 8.96359 13.6124 8.73709 13.7634C8.18209 14.1334 7.67159 14.1534 6.80609 13.8594C6.09809 13.6189 5.41809 13.4334 4.98909 13.2479C4.39659 12.9914 4.16959 12.1359 5.05909 11.7329Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M5.41848 11.7956C9.20448 10.1031 13.8605 8.16357 14.5415 7.88907C16.1735 7.23007 16.774 7.62107 16.5985 8.89457C16.4355 10.0736 15.857 13.7216 15.4515 16.1671C15.2125 17.6066 14.5145 17.9236 13.6055 17.3356C13.036 16.9686 10.744 15.4586 10.188 15.0191C9.75798 14.6796 9.31248 14.2876 9.83298 13.7201C10.007 13.5306 10.968 12.6031 11.6865 11.9131C12.103 11.5126 11.9545 11.3151 11.452 11.6591C10.5305 12.2906 9.02298 13.2901 8.75398 13.4716C8.24148 13.8166 7.75998 13.8996 6.92198 13.6361C6.26148 13.4281 5.62348 13.2266 5.29098 13.0971C4.54798 12.8091 4.53798 12.1891 5.41848 11.7956Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77602 11.8585C9.27102 10.321 13.7935 8.44651 14.418 8.18701C16.0555 7.50801 16.558 7.63801 16.3075 9.14201C16.1275 10.223 15.6085 13.8015 15.1945 16.029C14.949 17.35 14.398 17.5065 13.532 16.935C13.1155 16.66 11.013 15.2695 10.5565 14.943C10.14 14.6455 9.56552 14.2875 10.286 13.5825C10.5425 13.3315 12.223 11.7265 13.5325 10.4775C13.704 10.3135 13.4885 10.044 13.2905 10.1755C11.5255 11.346 9.07852 12.9705 8.76702 13.182C8.29652 13.5015 7.84452 13.648 7.03352 13.415C6.42052 13.239 5.82202 13.029 5.58902 12.949C4.69152 12.641 4.90452 12.242 5.77602 11.8585Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_509_752",
    x1: 4.929,
    y1: 4.929,
    x2: 19.071,
    y2: 19.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33BEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A85D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_509_752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.f78eb09486f26adfebdf7000511389ae.svg";
export { ForwardRef as ReactComponent };